import { useMemo } from 'react'
import { FieldType, Column, Table, Section } from '../../../../../features/ui'
import { Perception } from '../../../../fiscal-documents'

type Props = {
    perceptions: Perception[]
}

export const InvoicePerceptionTable = (props: Props) => {
    const { perceptions } = props

    const columns: Column[] = useMemo(() => [
        {
            name: 'name',
            type: FieldType.TEXT,
            label: 'Percepción',
        },
        {
            name: 'yield',
            type: FieldType.PERCENTAGE,
            label: 'Alícuota'
        },
        {
            name: 'amount',
            type: FieldType.PRICE,
            label: 'Monto'
        }
    ], [perceptions])

    return (
        <Section id="invoicePerceptionTable" space={12}>
            <Table
                columns={columns}
                rows={perceptions}
                rowId="name"
                alignRight
                readOnly
            />
        </Section>
    )
}
